import { registerTour } from "../tourRegistry";

function getSteps() {
  const totalSteps = 6;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'cc-overview',
      title: `Credit Card Register <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'Manage your credit card transactions here. This register works like a bank account but includes payment detection and tracking features specific to credit cards.',
      attachTo: { element: '[data-tour="cc-page"]', on: 'bottom' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'cc-account-selector',
      title: `Account Selector <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: 'Choose which credit card account to view. If you have integration-connected cards, you can also select individual cards within an account.',
      attachTo: { element: '[data-tour="cc-account-selector"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'cc-enter-tx',
      title: `Enter Transactions <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: 'Record credit card charges here. Enter the date, payee, account, fund, and amount. For charges, the amount goes in the Debit column.',
      attachTo: { element: '[data-tour="cc-enter-tx"]', on: 'bottom' },
      beforeShowPromise() {
        window.dispatchEvent(new Event("tour:expand-entry-form"));
        return new Promise((resolve) => setTimeout(resolve, 400));
      },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'cc-payment-detection',
      title: `Payment Detection <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: 'When connected via Plaid, T3 Books automatically detects credit card payments. Look for the sync icon — it shows payments that were detected from your bank and need to be matched to your records.',
      attachTo: { element: '[data-tour="cc-payment-detection"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'cc-register-table',
      title: `Transaction Register <span class="t3-shepherd-step-count">${stepCounter(5)}</span>`,
      text: 'Your credit card transaction history. Click any row to edit or inspect. Amounts are split into debit (charges) and credit (payments) columns.',
      attachTo: { element: '[data-tour="cc-register-table"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'cc-actions',
      title: `Actions <span class="t3-shepherd-step-count">${stepCounter(6)}</span>`,
      text: 'Import transactions from CSV, connect to your bank via Plaid, or manage linked transactions from here.',
      attachTo: { element: '[data-tour="cc-actions"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'creditCards',
  pathPattern: '/upkeep/credit-cards',
  getSteps,
  label: 'Credit Cards Tour',
});
